import React, { useState, createContext, useEffect } from "react";
import UserService from "../keycloak/UserService";

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const currusername = UserService.getUsernames();
  const [data, setData] = useState([]);
  const [userId, setUserId] = useState();
  const [username, setUsername] = useState(currusername);

  const [addNetwork, setAddNetwork] = useState({
    createdBy: parseInt(localStorage.getItem(userId)),
    // createdBy: userId ? parseInt(userId) : '',
    name: "",
    description: "",
    publicUrl: "",
    regionId: "southeastasia",
    numberOfNodes: 4,
    networkStatus: "pending",
    versionTag: "v1.0",
    active: false,

  });
  const [addAdmin, setAddAdmin] = useState({
    email: "",
    networkId: "",
  });

  const updateAdminData = (data) => {
    setAddAdmin((prev) => ({ ...prev, ...data }));
  };

  const updateNetworkData = (data) => {
    setAddNetwork((prev) => ({ ...prev, ...data }));
  };

  useEffect(() => {
    setAddNetwork((prev) => ({ ...prev, createdBy: userId }));
  }, [userId]);

  return (
    <AdminContext.Provider
      value={{
        data,
        setData,
        addNetwork,
        setAddNetwork,
        updateNetworkData,
        addAdmin,
        setAddAdmin,
        updateAdminData,
        userId,
        setUserId,
        username,
        setUsername,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
